if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    connectedCallback() {
      this.setHeight();
      if (window.ResizeObserver) {
        new ResizeObserver(this.setHeight.bind(this)).observe(this);
      }

      this.scrollHandler = this.setHeight.bind(this);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    disconnectedCallback() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }

    setHeight() {
      const scrollingPromotionSection = this.closest('.section');
      const scrollingPromotionTop = Math.abs(scrollingPromotionSection.getBoundingClientRect().top);
      const scrollingPromotionTopOffset = scrollingPromotionSection.offsetHeight - scrollingPromotionTop;
      document.documentElement.style.setProperty('--scrolling-promotion-top-offset', `${scrollingPromotionTopOffset}px`);
      document.documentElement.style.setProperty('--scrolling-promotion-height', `${scrollingPromotionSection.offsetHeight}px`);
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
